import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Providers } from '@/auth/Providers';
import { StaffGate } from '@/auth/StaffGate';
import { BootGate } from '@/shell/BootGate';
import { App } from '@/App';
import { env } from '@/env';
import { initI18n } from '@/i18n';
import '@marcianus/design/tokens/tokens.css'; // paleta + escalas (tipo, espaço, motion)
import '@marcianus/design/theme/theme.css';  // temas claro/escuro dinâmicos
import '../../../packages/design/components/mds.css';    // o design system COMPLETO — o mesmo do www
import '@/styles.css';                 // camada de CONSOLA: só o que é próprio de um ecrã grande

// Harness de QA visual: em preview, a consola corre sobre dados de amostra.
// Import dinâmico — o módulo NÃO entra no bundle de produção.
if (env.preview) { const { installPreviewApi } = await import('@/mocks/preview'); installPreviewApi(); }

await initI18n();   // catálogos prontos antes do 1.º render

const el = document.getElementById('root');
if (!el) throw new Error('#root não encontrado');

createRoot(el).render(
  <StrictMode>
    <Providers>
      <StaffGate>
        {/* Depois do gate: TUDO pré-carregado de uma vez atrás do splash MDS —
            a partir daí a navegação entre páginas é instantânea (cache quente). */}
        <BootGate>
          <App />
        </BootGate>
      </StaffGate>
    </Providers>
  </StrictMode>,
);
